import React from 'react';

import { Contract } from '@/types/ContractType';

interface Props {
  contract?: Contract;
  propertyState?: string; // Kept for backward compatibility
}

const Taxes = ({ contract, propertyState }: Props) => {
  // Priority: contract product > agentSellerInfo > prop > fallback
  const state =
    contract?.product?.address?.state ||
    contract?.agentSellerInfo?.propertyState ||
    propertyState ||
    'N/A';

  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Real Estate Taxes and Assessed Value
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          In {state}, taxing authorities (school districts and municipalities)
          and property owners may appeal the assessed value of a property at the
          time of sale, or at any time thereafter. A successful appeal by a
          taxing authority may result in a higher assessed value for the
          property and an increase in property taxes. Also, periodic county-wide
          property reassessments may change the assessed value of the property
          and result in a change in property tax.
        </li>
      </ol>
    </div>
  );
};

export default Taxes;
